import { REHYDRATE } from "redux-persist";
import { ANY_FIELD_UPDATE, updatedObject } from "../actions/formActions";
import {
    PRIVACY_SETTING_INIT,
    PRIVACY_SETTING_FETCH_BEGIN,
    PRIVACY_SETTING_FETCH_SUCCESS,
    PRIVACY_SETTING_FETCH_FAIL,
    PRIVACY_SETTING_UPDATE_BEGIN,
    PRIVACY_SETTING_UPDATE_SUCCESS,
    PRIVACY_SETTING_UPDATE_FAIL,
} from "../actions/privacySettingActions";

import { LOGOUT } from "../actions/loginStateActions";

const INITIAL_STATE = {
    data: {
        address: false,
        annualVolume: false,
        brCopy: false,
        brNo: false,
        buildingNo: false,
        companyBio: false,
        companyCertifications: false,
        companyImages: false,
        contactPerson: false,
        employeeNo: false,
        factorySize: false,
        location: false,
        mainProductionEquipments: false,
        mainProductionProcesses: false,
        majorCustomers: false,
        ownershipType: false,
        productCategories: false,
        productLiabilityInsurance: false,
        productPhoto: false,
        productProduced: false,
        productionEquipment: false,
        productionProcess: false,
        supplierList: false,
        topMarkets: false,
        yearEstablished: false,
    },
    status: "uninitialized",
};

export default function privacySettingReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REHYDRATE:
            return state;

        case PRIVACY_SETTING_INIT:
            return { data: INITIAL_STATE.data, status: "editing" };

        case PRIVACY_SETTING_FETCH_BEGIN:
            return { data: {}, status: "fetching" };

        case PRIVACY_SETTING_FETCH_SUCCESS:
            return {
                data: {
                    ...action.data,
                },
                status: "viewing",
            };

        case PRIVACY_SETTING_FETCH_FAIL:
            return { data: {}, status: "failed", failReason: action.reason };

        case PRIVACY_SETTING_UPDATE_BEGIN:
            return { data: { ...state.data }, status: "fetching" };

        case PRIVACY_SETTING_UPDATE_SUCCESS:
            return {
                data: {
                    ...action.data,
                },
                status: "fetching",
            };

        case ANY_FIELD_UPDATE: {
            if (action.storeName !== "privacySetting") return state;

            return {
                ...state,
                data: updatedObject(state.data, action.accessPath, action.newVal),
            };
        }

        case PRIVACY_SETTING_UPDATE_FAIL:
            return { data: { ...state.data }, status: "fetching", failReason: action.reason };

        case LOGOUT:
            return { data: {}, status: "uninitialized" };

        default:
            return state;
    }
}
